import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import api from 'api';
import Util from 'utility.js';
import { addMeal, addTraining, setLectureTaskData, setAppModeData, setProfileData, resetRecipe, closeModal, showMessage } from 'actions/index';

function LectureSeminarWorkTaskLoad() {
    const data = useSelector(state => state);
    const dispatch = useDispatch();
    const history = useHistory();
    const { lectureId } = useParams();

    useEffect(() => {
        const currentLectureId = Number(lectureId);

        api('lecturetask/info/' + currentLectureId).then(result => {
            dispatch(setAppModeData({ lectureId: currentLectureId }));
            dispatch(setAppModeData({ lectureInfoData: result.data }));
            dispatch(setAppModeData({ profileId: result.data.profile.id }));
            dispatch(setAppModeData({ undesirableFoods: result.data.undesirable_foods }));
            dispatch(setAppModeData({ watchAttributes: result.data.watch_attributes }));
            dispatch(setAppModeData({ watchAlergens: result.data.watch_alergens }));
            dispatch(setLectureTaskData(result.data));

            const lectureData = result.data.lecture_data;
            dispatch(resetRecipe());

            if (Array.isArray(lectureData.meal_types)) {
                lectureData.meal_types.forEach(m => {
                    const t = m.time.split(':');
                    dispatch(addMeal({
                        mealId: m.type * 1,
                        mealLength: 0,
                        startHour: t[0] * 1,
                        startMinute: t[1] * 1,
                        profiles: [Util.getActiveProfileId()]
                    }));
                });
            }

            if (Array.isArray(lectureData.activity_types)) {
                lectureData.activity_types.forEach(a => {
                    if (a.time === '' || a.length === '') return;
                    const t = a.time.split(':');
                    dispatch(addTraining({
                        start: t[0] + ':' + t[1],
                        length: a.length,
                        description: a.title,
                        profiles: [Util.getActiveProfileId()]
                    }));
                });
            }

            if (Util.isCurrentTaskSeminarWork()) {
                if (Util.isCurrentTaskSeminarWorkAssignment()) {
                    api('lecturetask/load/' + currentLectureId, { post: true, data: { lectureId: currentLectureId } }).then(res => {
                        if (typeof res.data.switch_to_profile === 'object') {
                            dispatch(setProfileData({ id: res.data.switch_to_profile.id, data: res.data.switch_to_profile }));
                        }
                        history.push('/plan');
                    });
                } else {
                    api('lecturetask/load-latest/' + currentLectureId, { post: true, data: { lectureId: currentLectureId } }).then(res => {
                        dispatch(closeModal());
                        dispatch(showMessage({ show: true, type: 'success', message: 'Byl nahrán uložený úkol "' + res.data.task_meta.title + '"' }));
                        history.push('/plan');
                    });
                }
            } else {
                history.push('/plan');
            }
        });
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    return null;
}

export default LectureSeminarWorkTaskLoad;
